import { createRoot } from 'react-dom/client'
import { AppWrapper } from './AppWrapper.tsx'
import './index.css'

const root = createRoot(document.getElementById('root'));
root.render(<AppWrapper />);
